module.exports = __webpack_public_path__ + "static/media/hero.a403faf7.jpg";